var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMacIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29710_22041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0118 9.60762C12.7198 10.256 12.5792 10.5458 12.2037 11.1181C11.678 11.9177 10.9365 12.9162 10.0205 12.9226C9.20498 12.93 8.99449 12.3905 7.88704 12.4C6.78064 12.4053 6.55006 12.9331 5.73348 12.9247C4.81642 12.9162 4.11514 12.0171 3.58944 11.2186C2.11919 8.97932 1.9637 6.35401 2.8723 4.9578C3.5154 3.96775 4.53189 3.386 5.48703 3.386C6.46015 3.386 7.07152 3.92015 7.8754 3.92015C8.65602 3.92015 9.13094 3.38494 10.2564 3.38494C11.1068 3.38494 12.0059 3.84823 12.649 4.64788C10.5462 5.80081 10.8878 8.80374 13.0118 9.60762ZM9.40172 2.49115C9.81107 1.96545 10.122 1.22398 10.0089 0.46875C9.34143 0.514233 8.56082 0.940502 8.10493 1.49264C7.69136 1.99613 7.34865 2.74289 7.48193 3.46533C8.21071 3.4886 8.96488 3.05386 9.40172 2.49115Z",
    fill: "#8E9095"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29710_22041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5391,
    height: 13.5391,
    fill: "white",
    transform: "translate(0.953125 0.203125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacIcon);
export default __webpack_public_path__ + "static/media/MacIcon.1cea94de3133dec0ec4e1747c0f9fad1.svg";
export { ForwardRef as ReactComponent };